/** @jsxImportSource @emotion/react */
import { useGetContentCardStyles } from "./index.styles";

const ContentCard = ({ children, flush = false }) => {
  const classes = useGetContentCardStyles();

  return (
    <div css={classes.card}>
      <div css={classes.accent} />
      <div css={flush ? classes.bodyFlush : classes.body}>{children}</div>
    </div>
  );
};

export default ContentCard;
